import { render, staticRenderFns } from "./legal-icon.vue?vue&type=template&id=254e90cd"
import script from "./legal-icon.vue?vue&type=script&lang=js"
export * from "./legal-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports